import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, withDebugTracing } from '@angular/router';
import { first, subscribeOn } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';


@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss']
})
export class BreadCrumbsComponent implements OnInit {

  urlPage: string = "";
  urls: string[] = [];
  divider: string = " ⟩ ";
  baseUrl: string = window.location.host;
  firstLoad:boolean=true;
  lastUrl:string = '';

  constructor(private router: Router, private localStorageService: LocalStorageService) {

  }

  ngOnInit(): void {
    let protocol = window.location.protocol;
    let domain = window.location.host;
    this.baseUrl = `${protocol}//${domain}`;


    let url = window.location.href;
    url = url.split("/").slice(3).join("/");
    url = url.replace(new RegExp('-', 'g'), " ");
    url = url.replace("%20", " ");

    url = this.makeUrlCooler(url);

    this.urls = url.split("/");

    this.urls.forEach((u,index)=>{
    
      this.urls[index] = this.urls[index].split(';')[0]
    })
    
    console.error("this tha url");
    console.error(this.urls)

    

    this.router.events.subscribe((val: any) => {
      if (val instanceof NavigationEnd) {
        //console.warn(val.urlAfterRedirects);
        let url: string = val.urlAfterRedirects;
        url = url.replace("%20", " ");
        url = this.makeUrlCooler(url);
        // url.replace(new RegExp('/','g'),' > ');
        this.firstLoad=false;
        let arr = url.split('/');
        
        //console.error(arr);
        this.urls = arr;
        this.urls.forEach((u,index)=>{
          this.urls[index] = this.urls[index].split(';')[0]
        })
        this.lastUrl = this.urls[this.urls.length-1]
        this.localStorageService.setLastUrl(this.lastUrl);
        console.error("This da url from router");
        console.error(this.urls)
      }

    });
  }

  makeUrlCooler(url: string): string {
    url = url.replace('stepper/', '');
    return url;
  }

  redirect(u: string, index: number) {
    if (u == '/home' && index == 0) {
      this.router.navigate(['/home/dashboard'])
    } else {
      console.log(this.urls[index]);
      let uu = "";
      for (let i = 0; i <= index; i++) {
        if (this.urls[i] === " " || this.urls[i] === "") {
          continue;
        }
        uu = `${uu}/${this.urls[i]}`;
      }
      console.log(uu);
      this.router.navigate([uu]);
    }

  }

}
